export default "__VITE_ASSET__BubStxHo__"